// extracted by mini-css-extract-plugin
module.exports = {"container":"static-offer-paywall_container__UQoxa","header":"static-offer-paywall_header__gqvsE","lockIconWrapper":"static-offer-paywall_lockIconWrapper__FYf0h"};